import "./App.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { useState } from "react";
import RootAuth from "./rootAuth";
import Page404 from "./rootAuth/404page";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {
  googleCredentialsClientId,
  smartElementKey,
} from "./Environment";
import { PlanValidationProvider } from "@/context/paymentContext";

(window as any).Smart = (window as any).Smart || {};
(window as any).Smart.License = smartElementKey;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 0,
      retry: 0,
    },
  },
});


function App() {
  const [Show, setShow] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const allowRoute = (value: boolean) => {
    setShow(value);
  };

  return (
    <GoogleOAuthProvider clientId={googleCredentialsClientId}>
      <QueryClientProvider client={queryClient}>
        {!Show && !notFound && (
          <RootAuth allow={allowRoute} notfound={setNotFound} />
        )}
        {Show && (
          <PlanValidationProvider>
            <AuthProvider>
              <ToastContainer
                position="top-center"
                className={"w-full top-0 p-0 h-fit !rounded-none"}
                autoClose={2000}
                hideProgressBar={false}
                bodyClassName={"m-0 p-0 flex justify-center items-center"}
                toastClassName={" m-0 p-0"}
                closeOnClick={true}
                pauseOnHover={false}
                draggable={true}
                theme="light"
              />
              <div translate="no">
                <RouterProvider router={router} />
              </div>
            </AuthProvider>
          </PlanValidationProvider>
        )}
        {notFound && !Show && <Page404 />}
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
